export interface Cell { x: number; y: number }
export const equal = (a: Cell, b: Cell): boolean => a.x === b.x && a.y === b.y;
export const DIRECTIONS: Cell[] = [{ x: 0, y: -1 }, { x: 1, y: 0 }, { x: 0, y: 1 }, { x: -1, y: 0 }];
export const MAZE = [
  '###################',
  '#.....#.....#.....#',
  '#.##..#.###.#..##.#',
  '#.................#',
  '#.##.###.#.###.##.#',
  '#....#...#...#....#',
  '####.#.#####.#.####',
  '...................',
  '####.#.#####.#.####',
  '#....#...#...#....#',
  '#.##.###.#.###.##.#',
  '#.................#',
  '#.##..#.###.#..##.#',
  '#.....#.....#.....#',
  '###################',
];
export function mazeStep(from: Cell, direction: Cell): Cell | null {
  const next = { x: (from.x + direction.x + 19) % 19, y: from.y + direction.y };
  return MAZE[next.y]?.[next.x] === '.' ? next : null;
}
export function pathDirection(from: Cell, to: Cell): Cell {
  const queue = [{ cell: from, first: { x: 0, y: 0 } }];
  const seen = new Set([`${from.x},${from.y}`]);
  for (let i = 0; i < queue.length; i++) {
    const item = queue[i];
    if (equal(item.cell, to)) return item.first;
    for (const dir of DIRECTIONS) {
      const next = mazeStep(item.cell, dir);
      if (!next) continue;
      const key = `${next.x},${next.y}`;
      if (seen.has(key)) continue;
      seen.add(key); queue.push({ cell: next, first: i === 0 ? dir : item.first });
    }
  }
  return { x: 0, y: 0 };
}
export function freeCell(body: Cell[], width = 20, height = 16, random = Math.random): Cell | null {
  const free: Cell[] = [];
  for (let y = 0; y < height; y++) for (let x = 0; x < width; x++) {
    const cell = { x, y };
    if (!body.some((segment) => equal(cell, segment))) free.push(cell);
  }
  return free.length ? free[Math.min(free.length - 1, Math.floor(random() * free.length))] : null;
}
export function snakeStep(body: Cell[], direction: Cell, grow: boolean, width = 20, height = 16): Cell[] | null {
  const head = { x: (body[0].x + direction.x + width) % width, y: (body[0].y + direction.y + height) % height };
  if ((grow ? body : body.slice(0, -1)).some((cell) => equal(cell, head))) return null;
  return [head, ...body.slice(0, grow ? body.length : -1)];
}
